import { Component } from '@angular/core';
import { AuthService } from 'src/app/core/_services/auth.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent {
  user!: any;

  constructor(private authService: AuthService) {
    // récupérer profil utilisateur
    const user = this.authService.userValue;
    if (user && Object.keys(user).length !== 0) {
      this.user = user;
    }
  }
}
